<template>
  <label class="group-label" for="weight">Weight</label>
  <fieldset id="weight">
    <br />
    <div v-if="units === 'metric'">
      <el-input-number
        id="kilos"
        v-model="kg"
        :min="0"
        :step="0.5"
      ></el-input-number>
      <label for="kilos">kg</label>
    </div>
    <div v-if="units === 'imperial'">
      <el-input-number id="stone" v-model="stone" :min="0"> </el-input-number>
      <label for="stone">st</label>
      <el-input-number id="lbs" v-model="lbs"> </el-input-number>
      <label for="lbs">lbs</label>
    </div>
  </fieldset>
</template>

<script>
import {
  kgToWholeStone,
  kgToWholeLbs,
  stoneAndLbsToKg,
} from "@/utils/conversions.js"

export default {
  name: "WeightFieldset",
  props: ["units", "weight"],
  emits: {
    "change-weight"(payload) {
      return !!payload.weight
    },
  },
  data() {
    return {
      kg: this.weight,
    }
  },
  computed: {
    stone: {
      get: function () {
        return kgToWholeStone(this.kg)
      },
      set: function (newStone) {
        this.kg = stoneAndLbsToKg(newStone, this.lbs)
      },
    },
    lbs: {
      get: function () {
        return kgToWholeLbs(this.kg)
      },
      set: function (newLbs) {
        this.kg = stoneAndLbsToKg(this.stone, newLbs)
      },
    },
  },
  updated() {
    this.$emit("change-weight", { weight: this.kg })
  },
}
</script>

<style scoped>
</style>